import __isEmpty from 'lodash/isEmpty';
import styles from './bondiatv.module.scss';
import Imatge from 'components/corporatiu/Imatge';
import Enllac from 'components/corporatiu/Enllac';
import Fila from 'components/corporatiu/Fila';
import GraellaCatchup from 'components/corporatiu/GraellaCatchup';
import Player from 'components/corporatiu/Player';

export default function Bondiatv(props) {
    const { items, urlGraella } = props;
    return (
        <div className={styles.wrapper}>
            <Fila tipus='fixed'>
                <div className={styles.innerWrapper}>
                    <div className={styles.capcalera}>
                        <h1 className='logoBondiaTV' title='Bon Dia TV'>
                            <Imatge
                                src='https://statics.3cat.cat/recursos/img/logos/bondiatv/logo_bondiatv_blanc_320x60.svg'
                                loading='lazy'
                                alt='BondiaTV'
                                width={300}
                                height={50}
                            />
                        </h1>
                        <Enllac
                            href='https://www.apuntmedia.es'
                            title='À Punt - La radiotelevisió i el web autonòmic valencians'
                            target='_blank'
                            className={styles.logo}
                        >
                            <Imatge
                                src='https://statics.3cat.cat/recursos/img/logos/bondiatv/logo_apunt_blanc_60x60.svg'
                                loading='lazy'
                                alt='À Punt'
                                width={50}
                                height={50}
                            />
                        </Enllac>
                        <Enllac
                            href='https://ib3.org/'
                            title='IB3 | Radiotelevisió de les Illes Balears'
                            target='_blank'
                            className={styles.logo}
                        >
                            <Imatge
                                src='https://statics.3cat.cat/recursos/img/logos/bondiatv/logo_IB3_blanc_60x60.svg'
                                loading='lazy'
                                alt='IB3'
                                width={50}
                                height={50}
                            />
                        </Enllac>
                        <Enllac href='https://www.3cat.cat/tv3/' title='TV3 - Televisió de Catalunya' className={styles.logo}>
                            <Imatge
                                src='https://statics.3cat.cat/recursos/img/logos/bondiatv/logo_TV3_blanc_70x60.svg'
                                loading='lazy'
                                alt='TV3'
                                width={58}
                                height={50}
                            />
                        </Enllac>
                    </div>
                    <div className={styles.player}>
                        <Player id='bondiatv' />
                    </div>
                    <div className={styles.textWrapper}>
                        <h2 className={styles.subtitol}>Què és Bon Dia Televisió?</h2>
                        <p>
                            <strong>Bon Dia TV</strong> és la plataforma de continguts audiovisuals de caràcter social i cultural
                            impulsada per la <strong>Corporació Valenciana de Mitjans de Comunicació (CVMC)</strong>, l&apos;
                            <strong>Ens Públic de Radiotelevisió de les Illes Balears (EPRTVIB)</strong> i la{' '}
                            <strong>Corporació Catalana de Mitjans Audiovisuals (CCMA)</strong>.
                        </p>
                        <p>
                            La programació està conformada per documentals, sèries, llargmetratges, programes de viatges, cuina,
                            literatura, cultura, ciència, tradicions i esports, en una llengua que es manifesta en diferents
                            variants segons el territori.
                        </p>
                    </div>
                    <h2 className={styles.subtitol}>Programació</h2>
                    <GraellaCatchup
                        items={items}
                        urlGraella={urlGraella}
                        mostraImatges={false}
                        estil='fosc'
                        canal='CAD_BND'
                        numDiesFuturs={9}
                    />
                </div>
            </Fila>
        </div>
    );
}
